import api from '../../../components/api';

export type ItemReportDataExpanded = {
  name: string,
  actualQuantity: number,
  estimatedQuantity: number,
  units: string,
  workareaName: string,
  projectId: number,
  projectName: string,
  jobType: number,
  sold: boolean,
  isApproved: boolean,
  isOnHold: boolean,
  lost: boolean,
  customerDisplayName: string
}

export const getItemsReportData = async (startDate?: string, endDate?: string): Promise<ItemReportDataExpanded[]> => {
  return (await api.get(`/web/datacenter/items-filtered/${startDate}/${endDate}`)).data
}